module.exports = __webpack_public_path__ + "img/50.6cdf84e2.png";